import * as ko from 'knockout';

import { BaseForm } from './base_form';
import { GlobalRegion } from '../models/global_region';
import * as globalRegionsApi from '../api/global_regions';
import { GlobalRegionData } from '../api/global_regions';
import { Deferred } from '../utils/deferred';
import { createWithComponent } from '../utils/ko_utils';
import { asI18nText } from '../i18n_text';

let template = require('raw-loader!../../templates/global_region_edit.html').default;

class GlobalRegionEditScreen extends BaseForm<GlobalRegionData> {
  public title: string;
  public createTitle: string;
  public editTitle: string;
  entity = ko.observable<GlobalRegion>(null);

  constructor(
    params: {
      baseName: string;
      title: string;
      createTitle: string;
      editTitle: string;
      id: string;
      initialName: string;
      result?: Deferred<GlobalRegionData>;
    },
    componentInfo: KnockoutComponentTypes.ComponentInfo
  ) {
    super(params);

    this.title = params.title;
    this.createTitle = params.createTitle;
    this.editTitle = params.editTitle;

    let request = params.id ? globalRegionsApi.retrieve(params.id) : undefined;
    let promise = Promise.all([request]).then(([data]) => {
      this.entity(new GlobalRegion(data));

      if (!data && params.initialName) {
        this.entity().nameJson(asI18nText(params.initialName));
      }
    });
    this.loadedAfter(promise).then(() => this.focusFirst(componentInfo.element));
  }

  save = () => {
    if (!this.entity()) {
      return;
    }

    if (this.validateLocal(this.entity)) {
      let data = this.entity().toData();
      this.executeSaveRequest(globalRegionsApi.save(data)).then((validation) => {
        this.onRemoteValidation(data, this.entity(), validation);
      });
    }
  };
}

export let globalRegionEdit = {
  name: 'global-region-edit',
  viewModel: createWithComponent(GlobalRegionEditScreen),
  template: template,
};

ko.components.register(globalRegionEdit.name, globalRegionEdit);
